<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject">step 1 | select font</div>
    <b-list-group class="mt-4">
      <button class="list-group-item list-group-item-action font-caslon active" data-font="font-caslon" v-on:click="selectFont">Caslon</button>
      <button class="list-group-item list-group-item-action font-ornate" data-font="font-ornate" v-on:click="selectFont">Ornate</button>
      <button class="list-group-item list-group-item-action font-rustic" data-font="font-rustic" v-on:click="selectFont">Rustic</button>
      <button class="list-group-item list-group-item-action font-se-airfoil-script" data-font="font-se-airfoil-script" v-on:click="selectFont">Se Airfoil Script</button>
      <button class="list-group-item list-group-item-action font-se-alako" data-font="font-se-alako" v-on:click="selectFont">SE Alako</button>
      <button class="list-group-item list-group-item-action font-se-arial" data-font="font-se-arial" v-on:click="selectFont">SE Arial</button>
      <button class="list-group-item list-group-item-action font-se-arriare-garde" data-font="font-se-arriare-garde" v-on:click="selectFont">SE Arriäre Garde</button>
      <button class="list-group-item list-group-item-action font-se-artistik" data-font="font-se-artistik" v-on:click="selectFont">SE Artistik</button>
      <button class="list-group-item list-group-item-action font-se-cowboys" data-font="font-se-cowboys" v-on:click="selectFont">SE Cowboys</button>
      <button class="list-group-item list-group-item-action font-se-dali" data-font="font-se-dali" v-on:click="selectFont">SE Dali</button>
      <button class="list-group-item list-group-item-action font-se-escapade" data-font="font-se-escapade" v-on:click="selectFont">SE Escapade</button>
      <button class="list-group-item list-group-item-action font-se-futura-md-bt" data-font="font-se-futura-md-bt" v-on:click="selectFont">SE Futura Md Bt</button>
      <button class="list-group-item list-group-item-action font-se-imperatorii" data-font="font-se-imperatorii" v-on:click="selectFont">SE ImperatorII</button>
      <button class="list-group-item list-group-item-action font-se-military" data-font="font-se-military" v-on:click="selectFont">SE Military</button>
      <button class="list-group-item list-group-item-action font-se-monogram" data-font="font-se-monogram" v-on:click="selectFont">SE Monogram</button>
      <button class="list-group-item list-group-item-action font-se-old-english" data-font="font-se-old-english" v-on:click="selectFont">SE Old English</button>
      <button class="list-group-item list-group-item-action font-se-old-newsprint" data-font="font-se-old-newsprint" v-on:click="selectFont">SE Old Newsprint</button>
      <button class="list-group-item list-group-item-action font-se-papyrus" data-font="font-se-papyrus" v-on:click="selectFont">SE Papyrus</button>
      <button class="list-group-item list-group-item-action font-se-parking-lot" data-font="font-se-parking-lot" v-on:click="selectFont">SE Parking Lot</button>
      <button class="list-group-item list-group-item-action font-se-pristina" data-font="font-se-pristina" v-on:click="selectFont">SE Pristina</button>
      <button class="list-group-item list-group-item-action font-se-simple-script" data-font="font-se-simple-script" v-on:click="selectFont">SE Simple Script</button>
      <button class="list-group-item list-group-item-action font-se-times-new-roman" data-font="font-se-times-new-roman" v-on:click="selectFont">SE Times New Roman</button>
      <button class="list-group-item list-group-item-action font-se-whimsical" data-font="font-se-whimsical" v-on:click="selectFont">SE Whimsical</button>
      <button class="list-group-item list-group-item-action font-se-girls-are-weird" data-font="font-se-girls-are-weird" v-on:click="selectFont">SE Girls Are Weird</button>
      <button class="list-group-item list-group-item-action font-se-script" data-font="font-se-script" v-on:click="selectFont">SE Script</button>
      <button class="list-group-item list-group-item-action font-se-sticks" data-font="font-se-sticks" v-on:click="selectFont">SE Sticks</button>
      <button class="list-group-item list-group-item-action font-se-export" data-font="font-se-export" v-on:click="selectFont">SE Export</button>
      <button class="list-group-item list-group-item-action font-stencil" data-font="font-stencil" v-on:click="selectFont">Stencil</button>
    </b-list-group>
    <b-button variant="default" class="mt-4 go-next" v-on:click="goNext">next</b-button>
    <input type="hidden" id="stencileaseFont" v-model="stencileaseFont" />
  </div>
</template>

<script>
import jQuery from 'jquery'

export default {
  components: {
    jQuery
  },
  data() {
    return {
      stencileaseFont: this.$store.state.product.textFontClass
    }
  },
  methods: {
    selectFont(evt) {
      let obj = evt.target
      this.stencileaseFont = jQuery(obj).text()

      jQuery('.list-group-item').removeClass('active');
      jQuery(obj).addClass('active');

      let font_cls = jQuery(obj).data('font');

      this.$store.dispatch('product/SET_TEXT_FONT', this.stencileaseFont)
      this.$store.dispatch('product/SET_FONT_CLASS', font_cls)
    },
    goNext(evt) {
      this.$store.dispatch('product/SET_OLDTAB', 0)

      this.$store.dispatch('product/SET_ACTIVETAB', 0)
      this.$store.dispatch('product/SET_ACTIVETAB', 1)
    }
  }
}
</script>
